import { render, staticRenderFns } from "./AvatarInline.vue?vue&type=template&id=5366bad4&scoped=true&"
import script from "./AvatarInline.vue?vue&type=script&lang=js&"
export * from "./AvatarInline.vue?vue&type=script&lang=js&"
import style0 from "./AvatarInline.vue?vue&type=style&index=0&id=5366bad4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5366bad4",
  null
  
)

export default component.exports